<template>
  <div class="app">
    <div class="content">
      <div class="content-boxs" v-for="(item,index) in list" :key="index" @click="goPage(item)">
        <img :src="item.icon" class="grid-img" />
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  data() {
    return {
      list:[
        {
          title:"双报到为民行",
          path:"/gzfw/sbdwmx",
          icon:require("@images/gzfw/bg-sbdwmx.png")
        },
        {
          title:"专家人才",
          path:"/hmhq/zyzx",
          icon:require("@images/gzfw/bg-zjrc.png")
        },
        {
          title:"问题墙回音壁",
          path:"/hmhq/problem",
          icon:require("@images/gzfw/bg-wtqhyb.png")
        },
      ]
    }
  },
  created() {
   
  },
  mounted() {
  },
  methods: {
    goPage(item){
      this.$router.push({
          path: item.path,
        })
    }
  },
}
</script>

<style lang="less" scoped>
.app{
  width: 100%;
  height: 100vh;
  background: #f6f7f9;
}
.content{
  width: 100%;
  padding: 10px 12px;
  box-sizing: border-box;
  &-boxs{
    width: 100%;
    box-sizing: border-box;
    margin: 16px 0px;
    img{
      width: 100%;
    }
  }
}
</style>
